export default "__VITE_ASSET__CmegNgG5__"